module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div style="text-align: center; padding-top: 20%"><h4>Page could not be found.</h4></div>';
}
return __p;
};
